import React from 'react';
import { ArrowRight, Check } from 'lucide-react';
import { services } from '../data/services';
export function Services() {
  return <section id="services" className="w-full bg-white py-16 lg:py-24" data-id="element-174" data-mp="1hw5neznggcq8">
      <div className="mx-auto max-w-7xl px-5 lg:px-8" data-id="element-175" data-mp="1dt9czw82jmxd">
        <div className="flex flex-col gap-5 border-b-4 border-brand-navy pb-8 lg:flex-row lg:items-end lg:justify-between" data-id="element-176" data-mp="1dvvlpz6p48h6">
          <div data-id="element-177" data-mp="13weg1hrg1ul7">
            <p className="text-xs font-bold uppercase tracking-[0.2em] text-brand-teal" data-id="element-178" data-mp="13w4rlym1rvhm">
              What we clean
            </p>
            <h2 className="mt-3 font-display text-3xl leading-[0.95] tracking-tight text-brand-navy sm:text-5xl" data-id="element-179" data-mp="z3to6ls3lrkb">
              THREE SERVICES.
              <br data-id="element-180" data-mp="q4q1z8xmww1l" />
              ONE LOCAL GUY.
            </h2>
          </div>
          <p className="max-w-sm text-base text-brand-navy/70" data-id="element-181" data-mp="q2n7ocpg8gr2">
            Bundle any two services and save 10%. Most neighbors do windows and
            gutters together, then pressure washing before the cookout.
          </p>
        </div>

        <div className="divide-y divide-brand-navy/10" data-id="element-182" data-mp="36bes5xbcdbi6">
          {services.map((service, index) => <article key={service.id} className="grid gap-8 py-10 lg:grid-cols-[auto_1fr_1fr] lg:items-center lg:gap-12 lg:py-14" data-id="element-183" data-mp="3b3zksviihik4" data-mpi={index}>
              <p className="font-display text-5xl leading-none tracking-tight text-brand-blue/25 lg:text-7xl" aria-hidden="true" data-id="element-184" data-mp="32actpip913h9">
                0{index + 1}
              </p>

              <div data-id="element-185" data-mp="3u0r06tuxndiw">
                <div className="flex flex-wrap items-center gap-3" data-id="element-186" data-mp="3u194mdrr0y1w">
                  <h3 className="font-display text-2xl tracking-tight text-brand-navy sm:text-3xl" data-id="element-187" data-mp="3g17t84duy886">
                    {service.name.toUpperCase()}
                  </h3>
                  {service.isNew && <span className="rounded-full bg-brand-navy px-3 py-1 text-[0.65rem] font-bold uppercase tracking-wide text-white" data-id="element-188" data-mp="24mcgwp2ooius">
                      Newly added
                    </span>}
                  <span className="rounded-full bg-brand-sky px-3 py-1 text-xs font-bold text-brand-blue" data-id="element-189" data-mp="1pjayvqqe67zw">
                    {service.startingAt}
                  </span>
                </div>
                <p className="mt-4 max-w-md text-base leading-relaxed text-brand-navy/70" data-id="element-190" data-mp="1gq7qhwulslc4">
                  {service.blurb}
                </p>
                <ul className="mt-5 flex flex-wrap gap-x-5 gap-y-2" data-id="element-191" data-mp="16tctxjhw4v0h">
                  {service.bullets.map(bullet => <li key={bullet} className="flex items-center gap-1.5 text-sm font-semibold text-brand-navy/80" data-id="element-192" data-mp="11u8i0l3l0j6g">
                      <Check className="h-4 w-4 shrink-0 text-brand-teal" aria-hidden="true" data-id="element-193" data-mp="sud4i9mk0c39" />
                      {bullet}
                    </li>)}
                </ul>
                <a href="#quote" className="mt-6 inline-flex items-center gap-2 text-sm font-bold text-brand-blue hover:text-brand-blue-dark" data-id="element-194" data-mp="2n5ru8qfkebj0">
                  Get a price for {service.name.toLowerCase()}
                  <ArrowRight className="h-4 w-4" aria-hidden="true" data-id="element-195" data-mp="34i86nxvc9e4z" />
                </a>
              </div>

              <img src={service.image} alt={service.name} className="h-56 w-full rounded-3xl object-cover shadow-md lg:h-64" data-id="element-196" data-mp="39eynineywdrg" />
            </article>)}
        </div>
      </div>
    </section>;
}